import { useState } from "react";
import { AffiliateState } from "../../interfaces/affiliate";
import { AffiliateAdminRun } from "./AffiliateNicknameEditor";

export function CodeRevocationAction({
  code,
  disabled,
  run,
}: {
  code: AffiliateState["codes"][number];
  disabled: boolean;
  run: AffiliateAdminRun;
}) {
  const [reviewing, setReviewing] = useState(false);
  const [confirmation, setConfirmation] = useState("");
  const [accepted, setAccepted] = useState(false);
  if (code.revoked_at) return <span>Deleted · {code.revoked_at}</span>;
  if (!reviewing)
    return (
      <button
        type="button"
        disabled={disabled || accepted}
        title={
          disabled
            ? "Code deletion requires an available, verified backend with deletion support."
            : undefined
        }
        aria-label={`Delete code ${code.code}`}
        onClick={() => setReviewing(true)}
      >
        {accepted ? "Deletion accepted; awaiting backend state" : "Delete code"}
      </button>
    );
  return (
    <form
      aria-label={`Review deletion of ${code.code}`}
      onSubmit={async (event) => {
        event.preventDefault();
        if (disabled || confirmation !== code.code) return;
        if (await run("revoke_code", { code: code.code })) {
          setAccepted(true);
          setReviewing(false);
          setConfirmation("");
        }
      }}
    >
      <p>
        Permanently stops new signups through <strong>{code.code}</strong>.
        Existing linked traders, their fees and history are preserved. The
        deleted code stays in the audit history.
      </p>
      <label htmlFor={`delete-code-${code.code}`}>
        Type code to confirm deletion
        <input
          id={`delete-code-${code.code}`}
          autoComplete="off"
          disabled={disabled}
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
        />
      </label>
      <button type="submit" disabled={disabled || confirmation !== code.code}>
        Confirm code deletion
      </button>
      <button
        type="button"
        onClick={() => {
          setReviewing(false);
          setConfirmation("");
        }}
      >
        Cancel code deletion
      </button>
    </form>
  );
}
